/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { ENV_COUNTRY, ENV_FUNCTION_QUOTATION } from '../../../hooks/enviroment'

export async function serviceGetQuotationFilters(item) {
	return await axios({
		method: 'GET',
		url: `${ENV_FUNCTION_QUOTATION}/quotation-filters`,
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				return response.data.data
			} else {
				notification.error({
					message: response.data.error,
					description: response.data.message,
				})
				return response.data
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_QUOTATION}/quotation-filters`,
			})
		})
}

export async function serviceGetQuotationList(item) {
	let urlRequest = ''
	let dataSend = {}
	if (item.pharmacy !== 'general') {
		urlRequest = `${ENV_FUNCTION_QUOTATION}/tracking/${ENV_COUNTRY}/list`
		dataSend = {
			limit: 10,
			page: item.page,
			filter_id: item.type === 'default' ? [] : [item.type],
			pharmacy: item.pharmacy,
			status: item.status,
		}
	} else {
		urlRequest = `${ENV_FUNCTION_QUOTATION}/${ENV_COUNTRY}/list?page=${item.page}&limit=10`
		dataSend = {
			quotation_type: 'digital-recipe',
			status: item.status,
		}
	}
	return await axios({
		method: 'POST',
		url: urlRequest,
		data: dataSend,
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				return response.data.data
			} else {
				notification.error({
					message: response.data.error,
					description: response.data.message,
				})
				return response.data
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: urlRequest,
			})
		})
}
